var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 55,
    viewBox: "0 0 99 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.107 0.778289C96.7192 1.00205 58.3787 23.2318 46.4354 30.5088C44.4578 31.7152 41.9858 31.7152 40.0081 30.5088L0.0486547 6.31385V25.9364C-0.0676757 28.8647 -0.261565 33.2815 3.27682 35.3342L32.4855 52.2035C35.6942 53.7309 39.1551 54.4898 42.6062 54.4898C46.7359 54.4898 50.856 53.4002 54.5398 51.2404C66.5606 44.1678 85.154 33.2815 93.6462 28.3199C96.7289 26.5006 98.6581 23.2513 98.8132 19.6323V19.6031L98.4448 0L97.0973 0.778289H97.107Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo-4.81361b37d015e5cf3d3d57d03e6f8474.svg";
export { ForwardRef as ReactComponent };